import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { ConnectionState } from './use-pusher-channel';
import { StatusBox } from '../status-box';

export function PusherConnectionStatus({
  connectionStatus,
  errorMessage,
  statusClassName,
}) {
  switch (connectionStatus) {
    case ConnectionState.CONNECTING:
      return (
        <StatusBox type="info" className={statusClassName}>
          <i className="fas fa-circle-notch fa-spin fa-lg mr-2 text-info" />
          Connecting…
        </StatusBox>
      );
    case ConnectionState.ERROR:
      return (
        <StatusBox type="danger" className={statusClassName}>
          <i className="fas fa-exclamation-circle fa-lg mr-2 text-danger" />
          {errorMessage}
        </StatusBox>
      );
    default:
      return null; // connected
  }
}

PusherConnectionStatus.propTypes = {
  connectionStatus: PropTypes.oneOf(Object.values(ConnectionState)).isRequired,
  errorMessage: PropTypes.string,
  statusClassName: PropTypes.string,
};

PusherConnectionStatus.defaultProps = {
  errorMessage:
    'This service is temporarily unavailable. Please refresh and try again',
};
